(function() {
'use strict';

angular
    .module('TR')
    .service('hotelRoomService', hotelRoomService);

function hotelRoomService(
    $filter,
    basketService,
    $http,
    imageService,
    guidService,
    dateUtil,
    $rootScope
    ) {
    const imageDomain = TRPCONFIG.Domain.HotelImageCDN
        ? `https://${TRPCONFIG.Domain.HotelImageCDN}`
        : imageService.getImageDomain();

    const reAbsUrl = /https?:\/\//i;

    const service = {
        getBoardTotal,
        restructureData,
        getCancellationChargesService,
        getNoOfRooms,
        setBoardId,
        getImageUrl,
        payloadEntry,
        callMilesApi,
        boardBasis
    };
    let isSkywards = document.querySelector('body').getAttribute('data-skywards');
    let cancellationRequest;

    let boardPrices = [];
    let inclusionPayloadArr = [];
    function restructureData(hotel) {
        const roomsData = _getRoomsData(hotel);

        if (TRPCONFIG.Domain.LowestBoardTypePriceOnly === true) {
            return _lowestBoardTypePricesOnly(roomsData);
        }

        return roomsData;
    }


    function _lowestBoardTypePricesOnly(data) {
        return data.map(data => {
            data.Availability = data.Availability.map(room => {
                room.BoardTypes = room.BoardTypes.map(boardType => {
                    if (!_.isEmpty(boardType.Prices)) {
                        boardType.Prices = [_.minBy(boardType.Prices, price => price.Cost)];
                    }
                    return boardType;
                });
                return room;
            });
            return data;
        });
    }

    function _getRoomsData(hotel) {
        return _.map(hotel.Rooms, (r, i) => ({
                    Availability: _combineRatesForRoom(
                    r.FilteredAvailability || r.Availability,
                    _.keyBy(hotel.RoomDetails, 'MasterId'),
                    hotel
                ),
                Title: r.Title,
                nonInfants: r.nonInfants,
                isRoomKidsFree: r.isRoomKidsFree,
                Id: `id${i}`
            }));
    }

    function getImageUrl({ ImageUrl, NewImageUrl }) {
        const url = TRPCONFIG.Domain.HotelImageCDN ? NewImageUrl : ImageUrl;
        if (url) {
            return reAbsUrl.test(url)
                ? url.replace('http:', 'https:')
                : imageDomain + url;
        }
    }

    function _combineRatesForRoom(prices, masterRooms, hotel) {
        //restructure the provided room availability prices in to a more compact set of data, grouping
        //by the room and boardType also add in extra data from the master room object if available
        const combinedRates = [];
        inclusionPayloadArr = [];
        for (let i = 0; i < prices.length; i++) {
            const p = prices[i];

            const properties = (!p.MasterId || p.MasterId === 0) ? { Description: p.RoomDescription } : { MasterId: p.MasterId };
            let room = _.find(combinedRates, properties); //find a room by it's master id if present otherwise use the title
            if (!room) {
                const master = _getMasterData(masterRooms, p.MasterId); //get the master room data

                let masterDescription = master.MasterRoomDescription ? master.MasterRoomDescription : p.RoomDescription;

                room = {
                    Description: p.RoomDescription,
                    MasterRoomDescription: masterDescription,
                    BoardTypes: [],
                    ImageUrl: master.ImageUrl,
                    ExtraDescription: master.Description,
                    MasterId: p.MasterId
                };
                combinedRates.push(room); //add it to the array too
            }
            //sub board type finding when same boardTypeId for different sub boards
            let compareBoardTypeId = p.SupplierBoardTypeId > 0 ? p.SupplierBoardTypeId : p.BoardType;

            if (TRPCONFIG.Domain.LowestBoardTypePriceOnly) {
                compareBoardTypeId = p.BoardType;
            }

            //check if the board type already exists
            let board = _.find(room.BoardTypes, { BoardType: compareBoardTypeId });
            if (!board) {
                board = {
                    BoardType: p.BoardType,
                    BoardDescription: p.BoardDescription,
                    BoardDescriptionOriginal: p.BoardDescriptionOriginal,
                    SupplierBoardTypeId: p.SupplierBoardTypeId,
                    BTExclusions: p.BTExclusions,
                    BTInclusions: p.BTInclusions,
                    Prices: []
                };
                room.BoardTypes.push(board);
            }

            //push this price into the boards price list
            board.Prices.push(p);
            boardPrices.push(board.Prices);
            if (isSkywards) {
                getAccruedMiles(board, hotel);
            }
        }
        let rooms = [];
        hotel.RequestedRooms.forEach(() => {
            rooms.push({});
        });
        let hotelData = {
            Id: hotel.Id,
            Title: hotel.Title,
            Address: hotel.Address,
            Country: hotel.Country,
            Location: hotel.Location,
            Province: hotel.Province,
            MinCost: hotel.MinCost,
            CheckInDate: hotel.CheckInDate,
            RequestedRooms: rooms
        };
        try {
            sessionStorage.setItem('hotelData', JSON.stringify(hotelData));
        } catch (error) {
            console.error('Unable to create session storage, hotelData');
        }
        basketService.updateBasket();

        return combinedRates;
    }

    function _getMasterData(data, id) {
        //function so we can handle cases where the master id isn't present in our list
        const masterRoom = { Description: '', ImageUrl: '' };
        if (data && id && data[id]) {
            masterRoom.ImageUrl = getImageUrl(data[id]);
            masterRoom.Description = data[id].Description;
            masterRoom.MasterRoomDescription = data[id].Title;
        }
        return masterRoom;
    }

    function boardBasis(boardTypes) {
        let boardList = JSON.parse(sessionStorage.getItem('boardList'));
        for (let i = 0; i < boardList.length; i++) {
            return boardTypes.SupplierBoardTypeId;
        }
    }

    // These functions are for Skywards.
    function getFlightFares(price) {
        let defaultFlight = JSON.parse(sessionStorage.getItem('DefaultFlight'));
        let priceQtys = JSON.parse(sessionStorage.getItem('priceQtys')) ?
        JSON.parse(sessionStorage.getItem('priceQtys')) : defaultFlight ?
        defaultFlight.Details.Itinerary : null;
        let storeSelectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight')) ?
        JSON.parse(sessionStorage.getItem('storeSelectedFlight')) : defaultFlight ?
        defaultFlight.Details.Itinerary : null;

        if (storeSelectedFlight && storeSelectedFlight.AdultFare && priceQtys && priceQtys.AdultFareQuantity !== null) {
            let adultPrices = storeSelectedFlight.AdultFare.Amount * priceQtys.AdultFareQuantity;
            let childPrices = storeSelectedFlight.ChildFare.Amount * priceQtys.ChildFareQuantity;
            let infantPrices = storeSelectedFlight.InfantFare.Amount * priceQtys.InfantFareQuantity;

            let totalFlightsMinusTax = adultPrices + childPrices + infantPrices;
            return price + totalFlightsMinusTax;
        }
    }

    function displayBoardPrice(roomGridData, price, room, priceMode, marhabaCost, flightCostPerPerson, flightCostTotal, totalNonInfants) {
        let cost = price.Cost + ((marhabaCost || 0) / (roomGridData.length || 1)) + (flightCostTotal * totalNonInfants);
        return cost;
    }

    function setBoardId(availability, filteredAvailability) {
        boardPrices = [];
        let availabilityLength = (filteredAvailability.length < availability.length) ? filteredAvailability.length : availability.length;
        for (let a = 0; a < availabilityLength; a++) {
                availability[a].ProductId = guidService.uuid();
                filteredAvailability[a].ProductId = availability[a].ProductId;
        }
    }

    function getBoardTotal(roomGridData, priceMode, marhabaCost, flightCostPerPerson, flightCostTotal, totalNonInfants) {
        roomGridData.forEach(room => {
            let prices = room.Availability;
            for (let a = 0; a < prices.length; a++) {
                let boardTypes = prices[a].BoardTypes;
                for (let b = 0; b < boardTypes.length; b++) {
                    boardTypes[b].ProductId = prices[a].BoardTypes[b].Prices[0].ProductId;
                }
            }

            for (let i = 0; i < prices.length; i++) {
                let bt = prices[i].BoardTypes;
                for (let j = 0; j < bt.length; j++) {
                    let p = bt[j].Prices[0];
                    let inclusionPrice = displayBoardPrice(roomGridData, p, room, priceMode, marhabaCost, flightCostPerPerson, flightCostTotal, totalNonInfants);

                    let pricePlusFlight = getFlightFares(inclusionPrice);
                    bt[j].InclusionPrice = pricePlusFlight;
                }
            }
        });
    }

    function cleanPrice(price) {
        price = price.replace(/\D/g, '');
        price = Number(price);
        return price;
    }

    function getDepartureCode(legs) {
        for (let i = 0; i < legs.length; i++) {
            if (legs[i].LegType === 'outbound') {
                return legs[i].DepartureAirport.Code;
            }
        }
    }

    function getDepartureDate(legs) {
        for (let i = 0; i < legs.length; i++) {
            if (legs[i].LegType === 'outbound') {
                return legs[i].DepartureDate;
            }
        }
    }

    function removeDuplicateId(roomIds, parentRadio) {
        let dedupedIds = [];
        for (let i = 0; i < roomIds.length; i++) {
            if (roomIds[i] !== parentRadio) {
                dedupedIds.push(roomIds[i]);
            }
        }
        return dedupedIds;
    }

    function getIncludedRooms(clickedId, parent) {
        let radios = document.querySelectorAll('.room-select-radio.checked input');
        let parentRadio = parent.querySelector('.room-select-radio.checked input').value;
        let roomIds = [];
        if (radios.length) {
            for (let i = 0; i < radios.length; i++) {
                roomIds.push(radios[i].getAttribute('value'));
            }

            if (parentRadio !== clickedId) {
                roomIds.push(clickedId);
                roomIds = removeDuplicateId(roomIds, parentRadio);
            }

            cancellationRequest.RoomIds = roomIds;
            getCancellationIncludedRoomCharges(cancellationRequest);
        }
    }

    function getNoOfRooms(clickedId, parent) {
        if (sessionStorage.getItem('hotelData')) {
            let hotelData = JSON.parse(sessionStorage.getItem('hotelData'));

            if (hotelData.RequestedRooms.length > 1) {
                getIncludedRooms(clickedId, parent);
            }
        }
    }

    function getCancellationIncludedRoomCharges(req) {
        $http.post('/api/holidays/selectedroomscancellationcharges', req).then(function(res) {
            TRPCONFIG.Domain.CancellationData = res.data;
            $rootScope.$broadcast('multiRoomCancellationCharges', res.data);
            return res.data;
        });
    }

    function getCancellationChargesService(req) {
        cancellationRequest = req;
        $http.post('/api/holidays/cancellationcharges', req).then(function(res) {
            TRPCONFIG.Domain.CancellationData = res.data;
            return res.data;
        });
    }

    async function callMilesApi(payload, domainId) {
        try {
            let url = `/api/skywards/Accrual/getMiles?domainId=${domainId}&bookingChannelId=2`;

            const response = await fetch(url, {
                method: 'post',
                body: JSON.stringify(payload),
                mode: 'cors',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });

            const miles = await response.json();
            return miles;
        } catch (error) {
            console.log('error', error);
            throw error;
        }

    }

    function payloadEntry(id, trip, legs, hotel, price) {
        if (price !== undefined) {
            let pid = id;
            if (id == null) {
                pid = guidService.uuid();
            }
            let payload =
                {
                    id: pid,
                    price: cleanPrice($filter('roundedCurrency')(price)),
                    bookingDate: dateUtil.serialiseDate(Date.now()),
                    flights: [
                        {
                            departureAirportCode: getDepartureCode(legs),
                            departureDate: dateUtil.serialiseDate(getDepartureDate(legs))
                        }
                    ],
                    hotels: [
                        {
                            estabGroupIds: hotel.EstabGroupIds,
                            checkInDate: trip.HotelInfo.CheckInDate
                        }
                    ]
                };

            return payload;
        }

    }

    async function getAccruedMiles(board, hotel) {
        let trip = JSON.parse(localStorage.getItem('trip'));
        let storeSelectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight'));
        const defaultFlight = JSON.parse(sessionStorage.getItem('DefaultFlight'));

        if (sessionStorage.getItem('storeSelectedFlight') && storeSelectedFlight ||
            sessionStorage.getItem('DefaultFlight') && defaultFlight.Details.Itinerary) {
            let legs = storeSelectedFlight ? storeSelectedFlight.Legs : defaultFlight.Details.Itinerary.Legs;
            let domainId = TRPCONFIG.Domain.DomainId;

            board = await board;

            let inclusionPayload = payloadEntry(board.ProductId, trip, legs, hotel, board.InclusionPrice);

            inclusionPayloadArr.push(inclusionPayload);
            if (boardPrices.length === inclusionPayloadArr.length) {
                const inclusion = callMilesApi(inclusionPayloadArr, domainId);
                let promise = await Promise.all([inclusion]);
                let ip = promise[0];
                sessionStorage.setItem('hotelDetailsSkywards', JSON.stringify(ip));
                TRPCONFIG.Domain.SkywardsMilesToDisplay = ip[0].Miles;
            }
        }
    }
    return service;

}
})();
